import { Grid } from "@mui/material";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import { Deal, DealType } from "src/business/deal";
import { iconColorSuccess, iconBgSuccess, iconBgInfo, iconColorInfo } from "src/design/tokens";
import { StatCard } from "src/design";
import { useTranslation } from "react-i18next";

interface Props {
  deals: Deal[];
}

export const StatsRow = ({ deals }: Props) => {
  const { t } = useTranslation();
  const active = deals.filter((d) => d.active).length;
  const dealsCount = deals.filter((d) => d.type === DealType.DEAL).length;
  const eventsCount = deals.filter((d) => d.type === DealType.EVENT).length;

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          label={t("deals.stats.total")}
          value={deals.length}
          icon={<LocalOfferOutlinedIcon sx={{ fontSize: 18 }} />}
          iconBg={iconBgSuccess}
          iconColor={iconColorSuccess}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          label={t("deals.stats.activeNow")}
          value={active}
          icon={<BoltOutlinedIcon sx={{ fontSize: 18 }} />}
          iconBg={iconBgInfo}
          iconColor={iconColorInfo}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          label={t("deals.stats.deals")}
          value={dealsCount}
          icon={<ShowChartIcon sx={{ fontSize: 18 }} />}
          iconBg={iconBgInfo}
          iconColor={iconColorInfo}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          label={t("deals.stats.events")}
          value={eventsCount}
          icon={<EventNoteOutlinedIcon sx={{ fontSize: 18 }} />}
          iconBg="#EDE9FE"
          iconColor="#7C3AED"
        />
      </Grid>
    </Grid>
  );
};
